import React, { useState } from 'react'
import PrimaryModal from '../../UI/Modal/PrimaryModal';
import Loader from '../../UI/Loader/Loader';
import SuccessAlert from '../../UI/Alert/SuccessAlert';
import { SaveTaskFormSchema } from '../../../schemas';
import { Form, Formik } from 'formik';
import { FormikInput, PrimaryButton } from "../../UI";
import { useUserContext } from '../../../contexts/UserContext';
import { createProductFeed, saveTask } from '../../../utils/APIs';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const SaveDuplicateTaskModal = ({ getSavedTasksData, data, handleClose }) => {
    const [saveLoading, setSaveLoading] = useState(false);
    const [saveError, setSaveError] = useState();
    const [showSuccess, setShowSuccess] = useState("");
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

    const handleSave = async (values) => {
        try {
            setSaveLoading(true);
            setSaveError("");
            let payload = {
                feature_id: content.products.adobe_target.id,
                saved_task_name: values.name,
                function_id: data.function_id,
                adobe_io_integration_id: data.adobe_io_integration_id,
            };
            if(data?.is_recursive_task) {
                payload = { ...payload,
                    time_interval: data.time_interval,
                    status: data.status,
                    regex: data?.regex,
                    recipient_emails: data?.recipient_emails,
                }
            }
            // A product feed is copied with its configuration; its saved task comes with it.
            const productFeedsTaskId = content?.tasks?.product_feeds?.id || 'product_feeds';
            const result = data.function_id === productFeedsTaskId
                ? await createProductFeed({
                    token: userData.token,
                    organizationId: userData.selectedOrganization.org_token,
                    data: { function_id: data.function_id, name: values.name, copy_from: data._id },
                })
                : await saveTask(
                    userData.token,
                    userData.selectedOrganization.org_token,
                    payload
                );
            setShowSuccess(result.message);
            handleCloseModal()
        } catch (error) {
            setSaveError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
        } finally {
            setSaveLoading(false);
        }
    };

    const handleCloseModal = () => {
        getSavedTasksData();
        handleClose(null)
    }
  return (
    <>
        {showSuccess && <SuccessAlert disappearTime={content.SAVE_TASK_MODAL_CONTENT.success_save_timeout} >{showSuccess}</SuccessAlert> }
        {saveLoading && <Loader />}
        <PrimaryModal title={content.SAVE_TASK_MODAL_CONTENT.title} hideModal={handleCloseModal}>
            <div className='p-6 space-y-6'>
                <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">{content.SAVE_TASK_MODAL_CONTENT.description}</h1>
                <Formik
                    initialValues={{
                        name: '',
                    }}
                    validationSchema={() => SaveTaskFormSchema(content.SAVE_TASK_MODAL_CONTENT)}
                    onSubmit={handleSave}
                >
                    {() => (
                        <Form className="space-y-4 md:space-y-6" action="#" id="registration-form">
                            <FormikInput
                                type="text"
                                id="name"
                                name="name"
                                label={content.SAVE_TASK_MODAL_CONTENT.formLabels.name}
                            />
                            {saveError && <p className="mt-2 text-sm text-red-5">{saveError}</p>}
                            <div className="flex items-center justify-end space-x-2">
                                <PrimaryButton type="submit">{ content.SAVE_TASK_MODAL_CONTENT.save_btn }</PrimaryButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </PrimaryModal>
    </>
  )
}

export default SaveDuplicateTaskModal